"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OriginalTextarea = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _input = require("../../__internal__/input");

var _formField = _interopRequireDefault(require("../../__internal__/form-field"));

var _characterCount = _interopRequireDefault(require("./character-count"));

var _input2 = _interopRequireDefault(require("../../__internal__/input/input.component"));

var _inputBehaviour = require("../../__internal__/input-behaviour");

var _utils = require("../../style/utils");

var _inputIconToggle = _interopRequireDefault(require("../../__internal__/input-icon-toggle"));

var _guid = _interopRequireDefault(require("../../utils/helpers/guid/guid"));

var _textarea = _interopRequireDefault(require("./textarea.style"));

var _i18nContext = _interopRequireDefault(require("../../__internal__/i18n-context"));

var _tooltipProvider = require("../../__internal__/tooltip-provider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const getFormatNumber = (value, locale) => new Intl.NumberFormat(locale).format(value);

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space); // Spacing props filtering is a temporary solution until FormField and all related components are refactored
// FIXME FE-3370

const filterOutSpacingProps = obj => Object.fromEntries(Object.entries(obj).filter(([key]) => !_propTypes2.default.space[key]));

let Textarea = /*#__PURE__*/function (_React$Component) {
  _inherits(Textarea, _React$Component);

  var _super = _createSuper(Textarea);

  function Textarea(...args) {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _super.call(this, ...args);

    _defineProperty(_assertThisInitialized(_this), "minHeight", 0);

    _defineProperty(_assertThisInitialized(_this), "id", _this.props.id || (0, _guid.default)());

    _defineProperty(_assertThisInitialized(_this), "_input", /*#__PURE__*/_react.default.createRef());

    _defineProperty(_assertThisInitialized(_this), "expandTextarea", () => {
      const textarea = _this._input.current;

      if (textarea.scrollHeight > _this.minHeight) {
        // Reset height to zero - IE specific
        textarea.style.height = "0px"; // Set the height so all content is shown

        textarea.style.height = `${Math.max(textarea.scrollHeight, _this.minHeight)}px`;
      }
    });

    return _this;
  }

  _createClass(Textarea, [{
    key: "componentDidMount",
    value:
    /**
     * A lifecycle method that is called after initial render.
     * Allows access to refs and DOM to set expandable variables
     */
    function componentDidMount() {
      if (this.props.expandable) {
        window.addEventListener("resize", this.expandTextarea); // Set the min height to the initially rendered height.
        // Without minHeight expandable textareas will only have
        // one line when no content is present.

        this.minHeight = this._input.current.clientHeight;
        this.expandTextarea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.expandable) {
        window.removeEventListener("resize", this.expandTextarea);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      const {
        expandable
      } = this.props;

      if (expandable) {
        this.expandTextarea();
      }
    }
  }, {
    key: "renderValidation",
    value: function renderValidation() {
      const {
        disabled,
        readOnly,
        inputIcon,
        size,
        error,
        warning,
        info,
        validationOnLabel
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_inputIconToggle.default, {
        disabled: disabled,
        readOnly: readOnly,
        inputIcon: inputIcon,
        size: size,
        error: error,
        warning: warning,
        info: info,
        useValidationIcon: !validationOnLabel
      });
    }
  }, {
    key: "overLimit",
    get: function () {
      const value = this.props.value || "";
      return value.length > parseInt(this.props.characterLimit, 10);
    }
  }, {
    key: "characterCount",
    get: function () {
      const value = this.props.value || "";
      const {
        characterLimit,
        warnOverLimit
      } = this.props;

      if (!characterLimit) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_characterCount.default, {
        isOverLimit: this.overLimit && warnOverLimit,
        value: getFormatNumber(value.length, this.context.locale()),
        limit: getFormatNumber(characterLimit, this.context.locale()),
        "data-element": "character-limit"
      });
    }
  }, {
    key: "render",
    value: function render() {
      const {
        label,
        size,
        children,
        characterLimit,
        enforceCharacterLimit,
        onChange,
        disabled,
        labelInline,
        readOnly,
        placeholder,
        rows,
        cols,
        validationOnLabel,
        adaptiveLabelBreakpoint,
        inputWidth,
        labelWidth,
        tooltipPosition,
        ...props
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_tooltipProvider.TooltipProvider, {
        tooltipPosition: tooltipPosition
      }, /*#__PURE__*/_react.default.createElement(_inputBehaviour.InputBehaviour, null, /*#__PURE__*/_react.default.createElement(_textarea.default, _extends({
        labelInline: labelInline
      }, (0, _utils.filterStyledSystemMarginProps)(props)), /*#__PURE__*/_react.default.createElement(_formField.default, _extends({
        label: label,
        disabled: disabled,
        id: this.id,
        labelInline: labelInline,
        labelWidth: labelWidth,
        isRequired: props.required,
        useValidationIcon: validationOnLabel,
        adaptiveLabelBreakpoint: adaptiveLabelBreakpoint
      }, filterOutSpacingProps(props)), /*#__PURE__*/_react.default.createElement(_input.InputPresentation, _extends({
        type: "text",
        size: size,
        disabled: disabled,
        readOnly: readOnly,
        inputWidth: typeof inputWidth === "number" ? inputWidth : 100 - labelWidth
      }, props), /*#__PURE__*/_react.default.createElement(_input2.default, _extends({
        ref: this._input,
        maxLength: enforceCharacterLimit && characterLimit ? characterLimit : undefined,
        onChange: onChange,
        disabled: disabled,
        readOnly: readOnly,
        labelInline: labelInline,
        placeholder: disabled ? "" : placeholder,
        rows: rows,
        cols: cols,
        id: this.id,
        as: "textarea"
      }, props)), children, this.renderValidation())), this.characterCount)));
    }
  }]);

  return Textarea;
}(_react.default.Component);

exports.OriginalTextarea = Textarea;

_defineProperty(Textarea, "contextType", _i18nContext.default);

Textarea.propTypes = { ...marginPropTypes,

  /** id of the input */
  id: _propTypes.default.string,

  /** Character limit of the textarea */
  characterLimit: _propTypes.default.string,

  /** Type of the icon that will be rendered next to the input */
  children: _propTypes.default.node,

  /** The visible width of the text control, in average character widths */
  cols: _propTypes.default.number,

  /** Adds disabled property */
  disabled: _propTypes.default.bool,

  /** Stop the user typing over the characterLimit */
  enforceCharacterLimit: _propTypes.default.bool,

  /** Allows the Textareas Height to change based on user input */
  expandable: _propTypes.default.bool,

  /** The content of the label for the input */
  label: _propTypes.default.string,

  /** Text applied to label help tooltip */
  labelHelp: _propTypes.default.node,

  /** When true, label is placed in line with an input */
  labelInline: _propTypes.default.bool,

  /** Spacing between label and a field for inline label, given number will be multiplied by base spacing unit (8) */
  labelSpacing: _propTypes.default.oneOf([1, 2]),

  /** Width of a label in percentage. Works only when labelInline is true */
  labelWidth: _propTypes.default.number,

  /** Width of an input in percentage. Works only when labelInline is true */
  inputWidth: _propTypes.default.number,

  /** Name of the input */
  name: _propTypes.default.string,

  /** Callback fired when the user types in the Textarea */
  onChange: _propTypes.default.func,

  /** Placeholder text for the component */
  placeholder: _propTypes.default.string,

  /** Adds readOnly property */
  readOnly: _propTypes.default.bool,

  /** The number of visible text lines for the control */
  rows: _propTypes.default.number,

  /** One of type of size to apply to the textarea */
  size: _propTypes.default.oneOf(["small", "medium", "large"]),

  /** The value of the Textarea */
  value: _propTypes.default.string,

  /** Whether to display the character count message in red */
  warnOverLimit: _propTypes.default.bool,

  /** Indicate that error has occurred
  Pass string to display icon, tooltip and red border
  Pass true boolean to only display red border */
  error: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** Indicate that warning has occurred
  Pass string to display icon, tooltip and orange border
  Pass true boolean to only display orange border */
  warning: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** Indicate additional information
  Pass string to display icon, tooltip and blue border
  Pass true boolean to only display blue border */
  info: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string]),

  /** When true, validation icon will be placed on label instead of being placed on the input */
  validationOnLabel: _propTypes.default.bool,

  /**
   * <a href="https://brand.sage.com/d/NdbrveWvNheA/foundations#/icons/icons" target="_blank">List of supported icons</a>
   *
   * Icon to display inside of the Textarea
   */
  inputIcon: _propTypes.default.string,

  /** Message to be displayed in a Tooltip when the user hovers over the help icon */
  tooltipMessage: _propTypes.default.string,

  /** Breakpoint for adaptive label (inline labels change to top aligned). Enables the adaptive behaviour when set */
  adaptiveLabelBreakpoint: _propTypes.default.number,

  /** Flag to configure component as mandatory */
  required: _propTypes.default.bool,

  /** Overrides the default tooltip position */
  tooltipPosition: _propTypes.default.oneOf(["top", "bottom", "left", "right"])
};
Textarea.defaultProps = {
  labelWidth: 30,
  disabled: false,
  expandable: false,
  enforceCharacterLimit: true,
  readOnly: false,
  warnOverLimit: false,
  validationOnLabel: false
};
var _default = Textarea;
exports.default = _default;